import type { CompletionDesignResponse, CompletionDesignStage } from './api';

export type CompletionAIContext = {
  parameters: CompletionDesignResponse['parameters'];
  stages: Array<Pick<CompletionDesignStage, 'stageNumber' | 'topMd' | 'bottomMd' | 'completion' | 'clusters'>>;
};

// Ask the mounted editor for a fresh snapshot; never cache another project's draft.
export function readCompletionAIContext(projectId: number): CompletionAIContext | undefined {
  let context: CompletionAIContext | undefined;
  window.dispatchEvent(new CustomEvent('fracsight-completion-context', {
    detail: { projectId, respond: (value: CompletionAIContext) => { context = value; } },
  }));
  return context;
}
